import React from "react";
import { useHistory, useLocation } from "react-router-dom";

const MainEnlaces = ({ nextp, prevp, setData, setUrl }) => {
  let { search } = useLocation();
  let query = new URLSearchParams(search);
  let LIMIT = 20;
  let start = parseInt(query.get("inicio")) || 1;
  let end = parseInt(query.get("fin")) || LIMIT;
  let history = useHistory();
  const handleNext = (e) => {
    history.push({ search: `?inicio=${start + LIMIT}&fin=${end + LIMIT}` });
    setUrl(nextp);
    setData([]);
  };
  const handlePrev = (e) => {
    history.push({ search: `?inicio=${start - LIMIT}&fin=${end - LIMIT}` });
    setUrl(prevp);
    setData([]);
  };
  const styleP = {
    textAlign: "center",
    color: "white",
    fontSize: "1.9rem",
    fontWeight: "bold",
    fontFamily: "sans-serif",
  };
  return (
    <>
      <p style={styleP}>
        Mostrando Pokemon del <b>{start}</b> al <b>{end}</b>
      </p>
      <div style={{ display: "flex", justifyContent: "center" }}>
        {prevp && (
          <button
            style={{
              border: "none",
              padding: ".3rem .5rem",
              textAlign: "center",
              fontWeight: "bold",
              background: "#00000060",
              display: "block",
              color: "#fff",
              borderRadius: ".4rem",
              margin: "0 .2rem",
            }}
            onClick={handlePrev}
          >
            atrás
          </button>
        )}
        {nextp && (
          <button
            style={{
              border: "none",
              padding: ".3rem .5rem",
              textAlign: "center",
              fontWeight: "bold",
              background: "#00000060",
              display: "block",
              color: "#fff",
              borderRadius: ".4rem",
              margin: "0 .2rem",
            }}
            onClick={handleNext}
          >
            siguiente pagina
          </button>
        )}
        <br />
      </div>
    </>
  );
};

export default MainEnlaces;
